export const VIEWPORT_EDGE_INSET = 8
export const TRIGGER_GAP = 6
/** Minimum space (px) before we prefer flipping to the other side. */
export const MIN_COMFORTABLE_SPACE = 120
